import React, { useState } from 'react'

import {
  Box,
  Button,
  Card,
  FormHelperText,
  IconButton,
  TextField,
  Typography,
} from '@material-ui/core'
import { Delete as DeleteIcon } from '@material-ui/icons'
import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { Controller, useFormContext } from 'react-hook-form'
import { isEmpty } from 'lodash'

import { Label } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'

const Suboperators = () => {
  const [suboperatorName, setSuboperatorName] = useState('')

  const { control, errors, watch, setValue } = useFormContext()
  const { isShow } = useThirdPartyManagementStepper()

  const suboperators = watch('suboperators') || []

  const handleAdd = () => {
    const normalizedName = suboperatorName?.trim()

    if (isEmpty(normalizedName) || suboperators.includes(normalizedName)) {
      setSuboperatorName('')
      return
    }

    setValue('suboperators', [...suboperators, normalizedName], {
      shouldValidate: true,
    })
    setSuboperatorName('')
  }

  const handleRemove = (suboperatorToRemove) => {
    setValue(
      'suboperators',
      suboperators.filter((suboperator) => suboperator !== suboperatorToRemove),
      { shouldValidate: true },
    )
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleAdd()
    }
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Typography variant="subtitle2">Sub-operadores do Fornecedor</Typography>

      <Controller
        name="suboperators"
        control={control}
        defaultValue={[]}
        as={<input type="hidden" />}
      />

      {!isShow && (
        <Label
          description="Informe os sub-operadores que se vinculam a esse fornecedor"
          item
        >
          <Box display="flex" gridGap={8} alignItems="center">
            <TextField
              fullWidth
              variant="outlined"
              placeholder="Nome do sub-operador"
              value={suboperatorName}
              onChange={(event) => setSuboperatorName(event.target.value)}
              onKeyDown={handleKeyDown}
              inputProps={{ maxLength: 255 }}
            />
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={18} />}
              onClick={handleAdd}
            >
              Adicionar
            </Button>
          </Box>
        </Label>
      )}

      <Card>
        <Table size="small" emptyMessage="Nenhum sub-operador adicionado.">
          <TableHead>
            <TableRow>
              <TableCell>Sub-operador(es) adicionado(s)</TableCell>
              <TableCell align="right">Ações</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {suboperators.map((suboperator) => (
              <TableRow key={suboperator}>
                <TableCell applyNoWrap disableTooltip={false}>
                  {suboperator}
                </TableCell>
                <TableCell align="right">
                  {!isShow && (
                    <IconButton onClick={() => handleRemove(suboperator)}>
                      <DeleteIcon />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      {!!errors?.suboperators && (
        <FormHelperText error>{errors.suboperators.message}</FormHelperText>
      )}
    </Box>
  )
}

export default Suboperators
